/**
 * Dashboard Service
 *
 * Reuses existing API endpoints for dashboard data.
 * @see Sprint 28 - Dashboard
 */

import { getCurrentStock, getStockKPIs } from '@/features/current-stock/services/current-stock.service';
import { lossesService } from '@/features/losses/services/losses.service';
import { inventoriesService } from '@/features/inventories/services/inventories.service';
import { purchaseOrdersService } from '@/features/purchase-orders/services/purchase-orders.service';
import { transfersService } from '@/features/transfers/services/transfers.service';

export const dashboardService = {
  getStockKPIs: () => getStockKPIs(),

  getLossKPIs: () => lossesService.getKPIs(),

  getLastValidatedInventory: () =>
    inventoriesService.list({
      status: 'VALIDATED' as any,
      limit: 1,
      sortBy: 'validatedAt',
      sortOrder: 'desc',
    }),

  getLowStockAlerts: () =>
    getCurrentStock({
      lowStockOnly: true,
      limit: 5,
      sortBy: 'currentStock',
      sortOrder: 'asc',
    }),

  getPendingOrders: () =>
    purchaseOrdersService.list({
      status: 'SENT,PARTIALLY_RECEIVED',
      limit: 5,
      sortBy: 'orderDate',
      sortOrder: 'desc',
    }),

  getPendingTransfers: () =>
    transfersService.list({
      status: 'PENDING,SHIPPED' as any,
      limit: 6,
      sortBy: 'createdAt',
      sortOrder: 'desc',
      role: 'all' as any,
    }),

  getMarketBreakdownData: () =>
    getCurrentStock({ limit: 100 }),
};
